import { styled } from '@mui/material/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, CircularProgress, Grid } from '@mui/material';

type Props = {
  isEditing: boolean;
  isDisabled?: boolean;
  onCancel: () => void;
  onEdit: (edited: boolean) => void;
  onSave?: () => void;
  isLoading?: boolean;
  editLabel?: string;
};

const StyledActionButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.only('xs')]: {
    width: '100%',
  },
  [theme.breakpoints.between('md', 'sm')]: {
    width: 'auto',
    marginBottom: 0,
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  [theme.breakpoints.only('xs')]: {
    width: '100%',
    padding: 5,
    flexDirection: 'column',
  },
  [theme.breakpoints.between('md', 'sm')]: {
    padding: 0,
    flexDirection: 'row-reverse',
  },
}));

// This looks like it is a generic component, yet is part of site settings. I think this can be moved into our ui components, maybe other features could utilize this.
const PAGE_NAME_ID = 'siteSettings.editSiteSettings.calibration';

const ActionButtons: React.FC<Props> = ({ onEdit, onCancel, isEditing, isDisabled, onSave, isLoading, editLabel }) => {
  return (
    <StyledGrid>
      {isEditing ? (
        <Grid display={'flex'} gap={2}>
          <StyledActionButton
            variant="outlined"
            onClick={() => {
              onCancel();
              onEdit(false);
            }}>
            <FormattedMessage id={`${PAGE_NAME_ID}.cancel`} />
          </StyledActionButton>
          <StyledActionButton
            type="submit"
            disabled={isLoading}
            {...(onSave && { onClick: onSave })}
            startIcon={isLoading ? <CircularProgress color="inherit" size={18} /> : null}>
            <FormattedMessage id={`${PAGE_NAME_ID}.save`} />
          </StyledActionButton>
        </Grid>
      ) : (
        <StyledActionButton disabled={isDisabled} onClick={() => onEdit(true)}>
          <FormattedMessage id={editLabel ? editLabel : `${PAGE_NAME_ID}.edit`} />
        </StyledActionButton>
      )}
    </StyledGrid>
  );
};

export default React.memo(ActionButtons);
